import { useDateTimeFormatter } from "./use-date-time-formatter";

export function DateTimeFormatter({
  value,
  className,
}: {
  value: Date;
  className?: string;
}) {
  const format = useDateTimeFormatter();

  return <span className={className}>{format(value)}</span>;
}
